export default __webpack_public_path__ + "static/media/P.7b649df2.png";